import { render, staticRenderFns } from "./PaymentOnboardSection.vue?vue&type=template&id=5bb92767&scoped=true"
import script from "./PaymentOnboardSection.vue?vue&type=script&lang=js"
export * from "./PaymentOnboardSection.vue?vue&type=script&lang=js"
import style0 from "./PaymentOnboardSection.vue?vue&type=style&index=0&id=5bb92767&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb92767",
  null
  
)

export default component.exports